webpackJsonp([67649646403732],{

/***/ 2025:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"StockTransferTemplateEdge","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"cursor","type":{"kind":"SCALAR","name":"String","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"node","type":{"kind":"OBJECT","name":"StockTransferTemplate","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-stock-transfer-template-edge-ae83d7f3bb11f3170065.js